"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DamageTypeToColor = void 0;
const enums_1 = require("../enums");
exports.DamageTypeToColor = {
    [enums_1.DamageType.None]: "white",
    [enums_1.DamageType.All]: "white",
    [enums_1.DamageType.Fire]: "red",
    [enums_1.DamageType.Frost]: "blue",
    [enums_1.DamageType.Nature]: "green",
    [enums_1.DamageType.Death]: "black",
    [enums_1.DamageType.Holy]: "yellow",
    [enums_1.DamageType.Chaos]: "purple",
    [enums_1.DamageType.Sonic]: "white",
    [enums_1.DamageType.Physical]: "brown",
};
